import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Bein símasala - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection>
                <ServiceHeader image="/img/thjonusta/bein-simasala.png" title="Bein símasala" />
                <p>
                    Bein s&iacute;masala er einn partur af &thorn;eim verkefnum sem a&eth;
                    &uacute;thringiver 1819 tekur a&eth; s&eacute;r. &Uacute;thringiveri&eth; sinnir
                    hverskyns verkefnum sem sn&uacute;a a&eth; s&ouml;lu fyrir
                    g&oacute;&eth;ger&eth;arf&eacute;l&ouml;g, fyrirt&aelig;ki og
                    f&eacute;lagasamt&ouml;k sem &thorn;urfa a&eth; n&aacute; til
                    &aacute;kve&eth;ins markh&oacute;ps, auka vitund landsmanna um starfsemi
                    s&iacute;na e&eth;a st&aelig;kka h&oacute;p vi&eth;skiptavina. Einnig kynnum
                    vi&eth; v&ouml;rur og &thorn;j&oacute;nustu sem fyrirt&aelig;ki bj&oacute;&eth;a
                    upp &aacute;.
                </p>
                <p>D&aelig;mi um verkefni sem falla &iacute; flokk beinnar s&iacute;mas&ouml;lu:</p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>B&oacute;kun s&ouml;lumanna &aacute; fundi</li>
                    <li>S&ouml;fnun netfanga fyrir markp&oacute;staherfer&eth;ir</li>
                    <li>Eftirfylgni markp&oacute;sta</li>
                    <li>
                        Uppl&yacute;singa&ouml;flun fyrir uppf&aelig;rslur
                        vi&eth;skiptavinaskr&aacute;r
                    </li>
                    <li>S&ouml;fnunar&aacute;t&ouml;k</li>
                    <li>Kynningarherfer&eth;ir &aacute; v&ouml;rum og &thorn;j&oacute;nustu</li>
                </ul>
                <p>
                    1819 &uacute;tb&yacute;r kl&aelig;&eth;skerasni&eth;nar lausnir beinnar
                    s&iacute;mas&ouml;lu fyrir hvert og eitt fyrirt&aelig;ki, &thorn;v&iacute;
                    verkefnin eru jafn &oacute;l&iacute;k og &thorn;au eru m&ouml;rg. Spara&eth;u
                    fyrirt&aelig;ki &thorn;&iacute;nu t&iacute;ma og peninga me&eth;
                    &thorn;v&iacute; a&eth; n&yacute;ta &thorn;&eacute;r &uacute;thringiver 1819 og
                    n&aacute;&eth;u betri &aacute;rangri!
                </p>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>{" "}
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
